import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RidMonosyllabicKeyboard } from '../../../../mechanics/rid-monosyllabic-keyboard/rid-monosyllabic-keyboard';

@Component({
  selector: 'app-monosyllabic-keyboard-page',
  imports: [RidMonosyllabicKeyboard],
  templateUrl: './monosyllabic-keyboard-page.html',
})
export class MonosyllabicKeyboardPage {
  protected readonly $activatedRoute = inject(ActivatedRoute);
  protected readonly $router = inject(Router);

  protected readonly mode = () => this.$activatedRoute.snapshot.queryParams['mode'] as 'GROUP' | 'KLANK' | 'BOTH';
}
